module.exports = __webpack_public_path__ + "banquet/components/images/lock.ff75b838ad491aa642499d6b10f5cbc7.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/lock.png
// module id = 1708
// module chunks = 1